import { classroomTips } from "@/mocks/homeMeta";
import SectionHeading from "./SectionHeading";

export default function Classroom() {
  return (
    <section id="classroom" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          index="07"
          eyebrow="How To Read"
          title="辟谣小课堂：吃瓜时不容易被带跑"
          desc="同样一条爆料，有人看出漏洞有人只看情绪。这几条是本站核验时最常用的动作，自己也能用。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="relative w-full h-[280px] md:h-full md:min-h-[360px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20wide%20scene%20of%20a%20magnifier%20and%20checklist%20on%20dark%20wood%2C%20warm%20amber%20accents%2C%20charcoal%20tones%2C%20film%20grain%2C%20no%20people%20no%20text%2C%20calm%20learning%20atmosphere&width=1400&height=560&seq=kd-class-01&orientation=landscape"
                alt="辟谣小课堂配图"
                title="蝌蚪黑料辟谣 核验方法"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="text-xs font-label tracking-widest text-primary-300 mb-2">
                  核验习惯
                </div>
                <p className="font-heading text-lg md:text-xl font-semibold text-background-50 leading-snug">
                  先找原出处，再排时间线，最后才谈结论。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {classroomTips.map((tip, idx) => (
                <article
                  key={tip.title}
                  className="rounded-lg bg-background-100 border border-background-200 hover:border-background-300 transition-colors p-5 flex flex-col"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                      <i
                        className={`${tip.icon} text-xl w-5 h-5 flex items-center justify-center`}
                      />
                    </span>
                    <span className="font-heading text-2xl font-bold text-background-300">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950">
                    {tip.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">
                    {tip.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}